import { normalizeNumber } from './number-utils'

export const amountFromString = (string: string): number => Number(normalizeNumber(string))
